import ThemeCustomization from "base/themes";
import AppRoutes from "base/routes";
import { QueryClientProvider } from "@tanstack/react-query";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CookiesProvider } from "react-cookie";
import { Toaster } from "react-hot-toast";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "base/config/queryClient";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <CookiesProvider>
          <ThemeCustomization>
            <AppRoutes />
            <Toaster
              position="top-right"
              reverseOrder={false}
              toastOptions={{ duration: 1600 }}
            />
          </ThemeCustomization>
        </CookiesProvider>
      </LocalizationProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
